import React from "react";
import {Pause, Play} from "lucide-react";
import {useSessionState} from "../pages/session/SessionStateContext";
import {useSessionEventListener} from "./hooks/useSessionEventListener";
import {EventType} from "../../apis";

interface Props {
    disabled?: boolean;
    disableReason?: string;
    playText: string;
    pauseText: string;
    playClassName?: string;
    pauseClassName?: string;
    onStart: () => void;
    onStop: () => void;
}

export function PlayPauseButton(props: Props) {
    const {
        disabled,
        disableReason,
        playText,
        pauseText,
        playClassName,
        pauseClassName,
        onStart,
        onStop,
    } = props;
    const { isSessionRunning, setIsSessionRunning } = useSessionState();

    useSessionEventListener(EventType.ForceStopSession, async () => {
        setIsSessionRunning(false);
    });

    function handleStart() {
        if (disabled) {
            return;
        }

        setIsSessionRunning(true);
        onStart();
    }

    function handleStop() {
        setIsSessionRunning(false);
        onStop();
    }

    if (isSessionRunning) {
        return (
            <div className="relative">
                <button
                    onClick={handleStop}
                    className={`${pauseClassName}`}
                >
                    <Pause className={`"h-5 w-5${pauseText ? ' mr-2' : ''}"`}/>
                    {pauseText}
                </button>
            </div>
        );
    }

    return (
        <div className="relative group">
            <button
                disabled={disabled}
                onClick={handleStart}
                className={`disabled:opacity-50 disabled:cursor-not-allowed ${playClassName}`}
            >
                <Play className={`"h-5 w-5${playText ? ' mr-2' : ''}"`} />
                {playText}
            </button>
            {disabled && disableReason && (
                <div className="absolute top-full mt-2 left-1/2 transform -translate-x-1/2 bg-gray-800 text-white text-sm rounded-lg px-2 py-1 shadow-lg opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap">
                    {disableReason}
                </div>
            )}
        </div>
    );
}
